function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import axios from 'axios';
import { Formik, Field, ErrorMessage } from 'formik';
import Select from 'react-select';
import PropTypes from 'prop-types';
import defaultPropTypes from '@demant/locations-spot/lib/js/utils/prop-types';
var SelectField = function SelectField(_ref) {
  var options = _ref.options,
    field = _ref.field,
    form = _ref.form;
  var customStyles = {
    singleValue: function singleValue(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        overflow: 'visible'
      });
    },
    control: function control(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        borderColor: '#B7B3AC',
        '&:hover': {
          borderColor: '#c6168d'
        },
        boxShadow: 'none',
        marginBottom: '0.5rem',
        borderRadius: state.menuIsOpen ? '3px 3px 0 0' : '3px',
        padding: '0.3rem',
        fontSize: '1rem'
      });
    },
    option: function option(provided, state) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        // eslint-disable-next-line no-nested-ternary
        backgroundColor: state.isSelected ? '#6B6867' : state.isFocused ? '#F7F6F4' : 'none',
        // eslint-disable-next-line no-nested-ternary
        color: state.isSelected ? 'white' : 'inherit',
        padding: '1rem',
        '&:not(:last-child)': {
          borderBottom: '1px solid #B7B3AC'
        },
        '&:last-child': {
          borderRadius: '0 0 3px 3px'
        }
      });
    },
    dropdownIndicator: function dropdownIndicator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        color: '#c6168d',
        padding: '0.4rem 0.4rem 0.4rem 0.6rem'
      });
    },
    indicatorSeparator: function indicatorSeparator(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        backgroundColor: '#D7D3CC',
        marginBottom: '-0.3rem',
        marginTop: '-0.3rem'
      });
    },
    menu: function menu(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        marginTop: 0,
        border: '1px solid #B7B3AC',
        borderTop: 0,
        boxShadow: 'none',
        borderRadius: '0 0 3px 3px',
        boxSizing: 'border-box'
      });
    },
    menuList: function menuList(provided) {
      return _objectSpread(_objectSpread({}, provided), {}, {
        padding: 0,
        margin: 0
      });
    }
  };
  return /*#__PURE__*/React.createElement(Select, {
    options: options,
    value: options ? options.find(function (option) {
      return option.value === field.value;
    }) : '',
    placeholder: field.placeholder,
    isClearable: false,
    isSearchable: false,
    onChange: function onChange(option) {
      return form.setFieldValue(field.name, option.value);
    },
    className: "location-detail-form__input location-detail-form__input--select",
    styles: customStyles
  });
};
SelectField.propTypes = {
  options: PropTypes.arrayOf(defaultPropTypes.formSelectOption).isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  field: PropTypes.any.isRequired,
  // eslint-disable-next-line react/forbid-prop-types
  form: PropTypes.any.isRequired
};
var CheckBox = function CheckBox(props) {
  return /*#__PURE__*/React.createElement(Field, {
    name: props.name
  }, function (_ref2) {
    var field = _ref2.field,
      form = _ref2.form;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
      type: "checkbox"
    }, props, {
      /* Because we get a string and not a boolean from the backend,
      we convert it to a boolean. If there is ANYTHING in the string
      (even 'false') it will resolve to true. So value should be empty
      for false (ie. checkbox not checked initially) */
      checked: !!field.value,
      onChange: function onChange() {
        form.setFieldValue(field.name, !field.value);
      }
    })), /*#__PURE__*/React.createElement("label", {
      dangerouslySetInnerHTML: {
        __html: props.label
      },
      htmlFor: props.id
    }));
  });
};
CheckBox.propTypes = {
  name: defaultPropTypes.string.isRequired,
  label: defaultPropTypes.string.isRequired,
  id: defaultPropTypes.string.isRequired
};
var OticonLocationDetailForm = function OticonLocationDetailForm(props) {
  var initialValues = props.Fields.reduce(function (acc, field) {
    acc[field.Name] = field.Value;
    return acc;
  }, {});
  var validate = function validate(values) {
    var errors = {};
    var keys = Object.keys(values);
    keys.forEach(function (key) {
      var _props$Fields$find = props.Fields.find(function (field) {
          return field.Name === key;
        }),
        required = _props$Fields$find.Required,
        pattern = _props$Fields$find.Pattern,
        errorMessage = _props$Fields$find.ErrorMessage;
      if (required && !values[key]) {
        errors[key] = errorMessage.Required;
      } else if (pattern) {
        var regex = new RegExp(pattern);
        if (!regex.test(values[key])) {
          errors[key] = errorMessage.Pattern;
        }
      }
    });
    return errors;
  };
  var handleFocusSingleLine = function handleFocusSingleLine(id) {
    document.getElementById("single-line-label-".concat(id)).classList.add('location-detail-form__label--focus');
  };
  var onSubmit = function onSubmit(values, _ref3) {
    var setSubmitting = _ref3.setSubmitting;
    // Create the payload
    var payload = {};
    payload.fields = Object.keys(values).map(function (key) {
      return {
        name: key,
        value: values[key]
      };
    });
    payload.id = props.configurationId;
    payload.clinic = props.clinicDetails;
    // call onFormWillSubmit callback with payload
    props.onFormWillSubmit(payload);

    // create the endpoint url
    var endPoint = "".concat(props.SubmitEndPoint);
    axios.post(endPoint, payload).then(function (response) {
      // Endpoint always responds with status code 200, so we have to
      // check for errors by checking that the `ErrorMessages` array in the
      // response is empty
      if (response.data.ErrorMessages.length > 0) {
        return props.onFormSubmitError(response.data.ErrorMessages[0].Value);
      }
      // call submitSuccess callback on props
      return props.onFormSubmitSuccess();
    }).catch(function (error) {
      props.onFormSubmitError(error);
    }).finally(function () {
      return setSubmitting(false);
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "location-detail-form"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "location-detail-form__heading"
  }, props.FormTitle), /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    validate: validate,
    onSubmit: onSubmit,
    render: function render(formikProps) {
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: formikProps.handleSubmit,
        className: "location-detail-form__form"
      }, props.Fields.map(function (field) {
        if (field.Type === 'select') {
          // convert keys to lowercase
          var options = field.Options.map(function (option) {
            return {
              value: option.Value,
              label: option.Label
            };
          });
          return /*#__PURE__*/React.createElement("div", {
            key: field.Name,
            className: "location-detail-form__row"
          }, /*#__PURE__*/React.createElement(Field, {
            name: field.Name,
            component: SelectField,
            options: options,
            placeholder: field.Placeholder,
            "aria-labelledby": "label-".concat(field.Name)
          }), /*#__PURE__*/React.createElement("div", {
            className: "location-detail-form__field-info"
          }, field.Label && /*#__PURE__*/React.createElement("div", {
            id: "label-".concat(field.Name)
          }, field.Label)));
        } else if (field.Type === 'checkbox') {
          return /*#__PURE__*/React.createElement("div", {
            key: "key-".concat(field.Name),
            className: "location-detail-form__row"
          }, /*#__PURE__*/React.createElement(CheckBox, {
            name: field.Name,
            checked: field.Value,
            id: "checkbox-".concat(field.Name),
            label: field.Label,
            className: "location-detail-form__input location-detail-form__input--checkbox ".concat(formikProps.errors[field.Name] ? 'location-detail-form__input--checkbox--error' : '')
          }), /*#__PURE__*/React.createElement("div", {
            className: "location-detail-form__field-info"
          }, /*#__PURE__*/React.createElement(ErrorMessage, {
            name: field.Name,
            component: "div",
            className: "location-detail-form__error location-detail-form__error--checkbox"
          })));
        }
        return /*#__PURE__*/React.createElement("div", {
          key: "key-".concat(field.Name),
          className: "location-detail-form__row"
        }, /*#__PURE__*/React.createElement(Field, {
          type: field.Type,
          name: field.Name,
          id: field.Name,
          "aria-labelledby": "single-line-label-".concat(field.Name),
          onFocus: function onFocus() {
            handleFocusSingleLine(field.Name);
          },
          className: "location-detail-form__input location-detail-form__singleline ".concat(formikProps.errors[field.Name] ? 'location-detail-form__singleline--error' : '')
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: field.Name,
          className: "location-detail-form__label",
          id: "single-line-label-".concat(field.Name)
        }, field.Placeholder), /*#__PURE__*/React.createElement("div", {
          className: "location-detail-form__field-info"
        }, field.Label && /*#__PURE__*/React.createElement("div", {
          id: "info-".concat(field.Name)
        }, field.Label), /*#__PURE__*/React.createElement(ErrorMessage, {
          name: field.Name,
          component: "div",
          className: "location-detail-form__error"
        })));
      }), /*#__PURE__*/React.createElement("button", {
        type: "submit",
        className: "location-detail-form__button",
        disabled: formikProps.isSubmitting
      }, props.SubmitLabel));
    }
  }));
};
OticonLocationDetailForm.propTypes = {
  Fields: PropTypes.arrayOf(defaultPropTypes.formField).isRequired,
  FormTitle: PropTypes.string.isRequired,
  SubmitLabel: PropTypes.string.isRequired,
  SubmitEndPoint: PropTypes.string.isRequired,
  configurationId: PropTypes.string.isRequired,
  onFormSubmitSuccess: defaultPropTypes.func,
  onFormSubmitError: defaultPropTypes.func,
  onFormWillSubmit: defaultPropTypes.func,
  clinicDetails: PropTypes.string
};
OticonLocationDetailForm.defaultProps = {
  onFormSubmitSuccess: function onFormSubmitSuccess() {
    return null;
  },
  onFormSubmitError: function onFormSubmitError() {
    return null;
  },
  onFormWillSubmit: function onFormWillSubmit() {
    return null;
  },
  clinicDetails: ''
};
export default OticonLocationDetailForm;